import { z } from "zod";

import { ReplayCommentStatus } from "@classview/shared-types";

const replaySettingSchema = z
  .object({
    isCommentEnabled: z.boolean(),
    commentType: z.nativeEnum(ReplayCommentStatus),
  })
  .refine(
    (data) => {
      // If comments are enabled, commentType cannot be NONE
      if (data.isCommentEnabled) {
        return data.commentType !== ReplayCommentStatus.NONE;
      }
      // If comments are disabled, commentType should be NONE
      return data.commentType === ReplayCommentStatus.NONE;
    },
    {
      message: "When comments are enabled, you must select who you let comment",
      path: ["commentType"],
    },
  );

type ReplaySettingFormData = z.infer<typeof replaySettingSchema>;

export { replaySettingSchema };
export type { ReplaySettingFormData };
